<template>
  <div class="form-custom-report">

    <div class="ibox col-40">
      <div class="ibox-title">
        Códigos
      </div>
      <div class="ibox-content">

        <div class="row">
          <div class="col-md-12">
            <input v-model="filter" class="input form-control"
                   placeholder="Pesquisar por: Nome ou parte do atributo">
          </div>
        </div>

        <table>
          <thead>
          <tr>
            <th>Código</th>
            <th>Caminho</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="code in currentCode" :key="code.key">
            <td>{{ code.key }}</td>
            <td>{{ code.value }}</td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>

    <div class="ibox col-60">
      <div class="ibox-title">
        Relatório
        <button :disabled="customReport.rows.length === 0" @click="save()" class="btn btn-primary float-right">
          Salvar
        </button>
        <button @click="cancel()" class="btn btn-outline float-right mr-2">
          Cancelar
        </button>
      </div>
      <div class="ibox-content">

        <table id="table-custom-report">
          <thead>
          <tr>
            <th>Título</th>
            <th>Formato</th>
            <th>Código</th>
            <th>
              <button class="btn btn-outline btn-sm nowrap" @click="addRow()">
                <PlusIcon/>Nova linha
              </button>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in customReport.rows" :key="index">
            <td>
              <input v-model="row[2]" class="form-control">
            </td>
            <td>
              <select v-model="row[1]" class="form-control">
                <option selected="selected" value="string">texto</option>
                <option value="to_f">número</option>
                <option value="to_f2">número (com ponto)</option>
                <option value="to_currency">moeda</option>
                <option value="to_date">data</option></select>
            </td>
            <td>
              <select v-model="row[0]" class="form-control">
                <option v-for="code in currentKeyCodes" :key="code">
                  {{ code }}
                </option>
              </select>
            </td>

            <td class="nowrap">
              <button class="btn btn-outline btn-sm mr-1"
                      @click="move(index - 1, index)"
                      :disabled="index === 0">
                <ArrowUpIcon size="1x"/>
              </button>
              <button class="btn btn-outline btn-sm mr-1"
                      @click="move(index + 1, index)"
                      :disabled="(index + 1) === customReport.rows.length">
                <ArrowDownIcon size="1x"/>
              </button>
              <button class="btn btn-outline btn-sm mr-1" @click="clone(index, row)">
                <CopyIcon size="1x"/>
              </button>
              <button class="btn btn-outline btn-sm" @click="remove(index)">
                <MinusIcon size="1x"/>
              </button>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import { ArrowDownIcon, ArrowUpIcon, CopyIcon, MinusIcon, PlusIcon } from 'vue-feather-icons'
  import { mapMutations } from 'vuex'

  export default {
    activated() {
      this.loadData()
    },
    components: { ArrowDownIcon, ArrowUpIcon, CopyIcon, MinusIcon, PlusIcon },
    computed: {
      currentCode() {
        const codes = Object.entries(this[`${this.type}Code`]).map(([k, v]) => ({key: k, value: v.path}))
        if (this.filter)
          return codes.filter(o => o.value.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
        else
          return codes
      },
      currentKeyCodes() {
        return Object.keys(this[`${this.type}Code`])
      }
    },
    data() {
      return {
        cloneCustomReport: '',
        cteCode: {},
        customReport: {
          rows: []
        },
        filter: '',
        modelPathPrefix: 'dfe',
        nameModel: 'CustomReport',
        nfeCode: {},
        type: 'nfe'
      }
    },
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      addRow() {
        this.customReport.rows.push([this.currentKeyCodes[0], 'string', '(título)'])
      },
      cancel() {
        this.customReport = JSON.parse(this.cloneCustomReport)
      },
      clone(index, row) {
        this.customReport.rows.splice(index, 0, [...row])
      },
      async findCustomReport() {
        this.openLoad()
        try {
          const path = this.buildPath()
          const response = await this.axios.get(`${path}/${this.type}`)
          this.customReport = this.$parse.toCamelcase(response.data)

          if (this.customReport.rows.length === 0)
            this.addRow()
          this.cloneCustomReport = JSON.stringify(this.customReport)
        } catch (e) {
          this.$notify.add(e, { type: 'error' })
        } finally {
          this.closeLoad()
        }
      },
      async loadCodes() {
        const key = 'codeCustomReportDfe'
        const codes = this.$ls.get(key)
        if (codes) {
          this.nfeCode = codes.nfe
          this.cteCode = codes.cte
          return
        }

        const response = await this.axios.get('dfe/custom_reports/code_custom_report')
        this.nfeCode = response.data.nfe
        this.cteCode = response.data.cte
        this.$ls.set(key, response.data)
      },
      async loadData() {
        this.setType()
        await this.loadCodes()
        await this.findCustomReport()
      },
      move(to, from) {
        const toRow = this.customReport.rows[to]
        const toFrom = this.customReport.rows[from]
        this.$set(this.customReport.rows, from, toRow)
        this.$set(this.customReport.rows, to, toFrom)
      },
      remove(index) {
        this.customReport.rows.splice(index, 1)
      },
      save() {
        this.asyncTemplateSave(this.customReport, {
          after: () => {
            this.$notify.add('Relatório salvo com sucesso!')
          }
        })
      },
      setType() {
        const type = this.$route.query.type
        if (type === 'nfe') {
          this.setNameBreadcrumb('Relatório Customizado NFe')
          this.type = type
        } else {
          this.setNameBreadcrumb('Relatório Customizado CTe')
          this.type = 'cte'
        }
      }
    },
    mixins: [ModelMapper],
    name: 'CustomReport'
  }
</script>

<style scoped>
  .form-custom-report {
    height: 100%;
    display: flex;
    flex-direction: row;
  }

  .ibox-content {
    overflow-y: auto;
  }

  .col-40 {
    margin-right: 8px;
    width: 40%;
    height: 95%;
  }

  .col-60 {
    width: 60%;
    height: 95%;
  }
</style>